import React from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { CalendarServiceInstance, addDays, formatTime, instancesForDay, sameDay, serviceColour } from "./calendarUtils";

interface Props {
  gridStart: Date;
  selectedDate: Date;
  instances: CalendarServiceInstance[];
  onSelectDate: (date: Date) => void;
  onOpen: (instance: CalendarServiceInstance) => void;
  mobile?: boolean;
}

export default function CalendarMonthView({ gridStart, selectedDate, instances, onSelectDate, onOpen, mobile }: Props) {
  const days = Array.from({ length: 42 }, (_, index) => addDays(gridStart, index));
  const month = selectedDate.getMonth();
  return (
    <div className={`calendar-month${mobile ? " calendar-month--mobile" : ""}`}>
      <div className="calendar-month-weekdays">{["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => <span key={day}>{mobile ? day[0] : day}</span>)}</div>
      <div className="calendar-month-grid">
        {days.map((day) => {
          const dayInstances = instancesForDay(instances, day);
          const selected = sameDay(day, selectedDate);
          return (
            <div key={day.toISOString()} className={`calendar-month-day${selected ? " is-selected" : ""}${day.getMonth() !== month ? " is-outside" : ""}`}>
              <button type="button" className="calendar-month-date" onClick={() => onSelectDate(day)} aria-pressed={selected} aria-current={sameDay(day, new Date()) ? "date" : undefined}>{day.getDate()}</button>
              {mobile ? (
                <div className="calendar-month-dots" aria-label={`${dayInstances.length} services scheduled`}>
                  {dayInstances.slice(0, 3).map((instance) => <span key={instance.serviceInstanceId} style={{ background: serviceColour(instance) }} />)}
                </div>
              ) : (
                <div className="calendar-month-events">
                  {dayInstances.slice(0, 3).map((instance) => (
                    <button key={instance.serviceInstanceId} type="button" style={{ ["--service-colour" as string]: serviceColour(instance) }} onClick={() => { onSelectDate(day); onOpen(instance); }}><strong>{instance.serviceName}</strong><span>{formatTime(instance.startDateTime)} – {formatTime(instance.endDateTime)}</span>{(instance.preRegistrationCampaignId || instance.postRegistrationCampaignId) && <MailOutlineIcon className="calendar-campaign-indicator" aria-label="Session communication configured" />}</button>
                  ))}
                  {dayInstances.length > 3 && <button type="button" className="calendar-month-more" onClick={() => onSelectDate(day)}>+{dayInstances.length - 3} more</button>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
